import { UploaderVariant } from 'shared/enums';

export const CREDENTIALS_PATH_VARIANTS: Record<UploaderVariant, string> = {
  [UploaderVariant.UserAvatar]: 'users/avatar',
  [UploaderVariant.AdminUserAvatar]: 'admin/users/avatar',
  [UploaderVariant.TournamentBanner]: 'tournaments/banners',
  [UploaderVariant.TournamentCard]: 'tournaments/cards',
};
